import AbstractView from '@/core/view/abstractView';
import template from './lifespanView.tpl';
import LogUtil from '@/core/utils/logUtil';
import styles from './style.module.scss';
import StepEvent from './steps/StepEvent';
import EventDispatcher from '@/core/event/eventDispatcher';
import StepFactory from './steps/stepFactory';
import StepViewController from './steps/stepViewController';

import JSONLoader from '@/core/loader/jsonLoader';
import AppStateModel from '../../model/appStateModel';
import CoreEvent from "@/core/event/coreEvent";


let stepFinishedHandler: ((event: CoreEvent) => void) | null = null;


class LifespanView extends AbstractView {

    private stepFactory:StepFactory
    private stepController?:StepViewController|null
    private animations:any


    constructor(id, data, params) {
        super(id, data, params);

        let assets = {};

        this.animations = this._data.animations;
        this._data.styles = styles;
        this._template = template({data: this._data, assets: assets});
        this.stepFactory = new StepFactory(this._data);
    }

    preload(completeCallback) {

        let jsonFile = this._data.model['lifespan'];

        function loadDataSuccessHandler(result) {

            AppStateModel.birthdayMap = result[0]['birthdayMap'];
            completeCallback();
        }

        function loadDataErrorHandler(error) {
            LogUtil.error('Loading JSON Error. Couldn´t load ', jsonFile, error);
        }

        JSONLoader.loadAll([jsonFile]).then(loadDataSuccessHandler.bind(this), loadDataErrorHandler.bind(this));
    }


    init() {

        stepFinishedHandler = (event) => this.onStepFinished(event);
        EventDispatcher.addEventListener(StepEvent.STEP_FINISHED, stepFinishedHandler);

        // node for the steps
        let steps = this._element?.querySelector('div#' + this._data.styles.steps) as HTMLElement;

        this.stepController = new StepViewController();
        this.stepController.initialize(steps, this.stepFactory);

        // show first view
        if (AppStateModel.canJumpToStepOnce()) {
            this.stepController.loadView('results');
        } else {
            this.stepController.loadView('gender_selection'); // ---- TODO edit here to start at a different step by default.
        }

    }

    onStepFinished(event:CoreEvent) {
        let data = event.data;
        this.stepController?.loadView(data.next_step);
    }

    render() {
        super.render();
    }

    destroy() {
        EventDispatcher.removeEventListener(StepEvent.STEP_FINISHED, stepFinishedHandler);
        if (this.stepController) {
            this.stepController.destroy();
            this.stepController = null;
        }
    }


}

export default LifespanView;
